import { MAPPINGS_APIS } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import { useAPIUtils } from "../../useAPIUtils";
import {
  IAppointmentCartItemsMappingListResponse,
  IAppointmentCartItemsMappingUpdateFilterBody,
} from "@/api_framework/api_modals/Mapping";
import { setAppointmentCartItemMappingUpdate } from "@/app_redux/reducers/slices/auth/mapping_slice";

AxiosCurlirize(axios, () => {});

export const useAppointmentCartItemsMappingUpdateAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError, toastNotification } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (subServiceId: string, body: IAppointmentCartItemsMappingUpdateFilterBody) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: any = await axios
          .put(`${MAPPINGS_APIS?.APPOINTMENT_CART_ITEMS_MAPPING_LIST?.baseURL}${subServiceId}/`, body, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IAppointmentCartItemsMappingListResponse>) => {
            if (res.data.status === true) {
              toastNotification(res.data.message);
              dispatch(setAppointmentCartItemMappingUpdate({ data: res.data.data as any }));
              return { status: true, message: null };
            } else {
              dispatch(setAppointmentCartItemMappingUpdate({ data: null }));
              return { status: false, message: null };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);

            return { status: false, message: null };
          });
        return response;
      } catch (e) {
        captureError(e);
      }
    },
    [dispatch],
  );
  return { execute };
};
